<template>
  <div>
    <b-row>
      <b-col sm="12" lg="12">
        <!-- <b-card
          class="mb-2 shadow"
          header-text-variant="light"
          header-tag="h6"
          header="Documents"
          bg-variant="secondary"
        > -->
        <div v-if="busy" class="d-flex justify-content-center mt-3">
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <el-upload
          class="upload-demo d-inline"
          ref="upload"
          action="string"
          multiple
          :show-file-list="false"
          :before-upload="handleChange"
          :http-request="uploadFiles"
        >
          <b-button @click="documentType = 'public'" class="mb-3 mr-3" size="sm"
            ><b-icon-plus-circle-fill class="mr-2"></b-icon-plus-circle-fill
            >Public</b-button
          >
        </el-upload>
        <el-upload
          class="upload-demo d-inline"
          ref="upload"
          action="string"
          multiple
          :show-file-list="false"
          :before-upload="handleChange"
          :http-request="uploadFiles"
        >
          <b-button @click="documentType = 'private'" class="mb-3" size="sm"
            ><b-icon-plus-circle-fill class="mr-2"></b-icon-plus-circle-fill
            >Privé</b-button
          >
        </el-upload>
        <b-table
          v-if="documents.length > 0 && loaded"
          id="documentsTable"
          striped
          small
          hover
          responsive
          :fields="fields"
          :items="documents"
        >
          <template v-slot:cell(date_encodage)="data">{{
            toDate(data.item.date_encodage)
          }}</template>
          <template v-slot:cell(isPrivate)="data">
            <b-icon-lock-fill
              v-if="data.item.isPrivate == 1"
              variant="danger"
            ></b-icon-lock-fill>
            <b-icon-unlock-fill v-else variant="success"></b-icon-unlock-fill>
          </template>
          <template v-slot:cell(intitule)="data">
            <span>{{ data.item.intitule }}</span>
          </template>
          <template v-slot:cell(note)="data">
            <span v-html="data.item.note"></span>
          </template>
          <template v-slot:cell(document)="data">
            <b-button
              @click="printImage(data.item)"
              v-if="data.item.mimeType.indexOf('image') == 0"
              class="thumbnail-img"
            >
              <img style="max-width: 300px" :src="toPath(data.item)" />
            </b-button>
            <div v-else-if="data.item.mimeType == 'application/pdf'">
              <b-button @click="fullScreen(data.item)" size="sm" class="btn-xs"
                ><b-icon-search></b-icon-search
              ></b-button>
            </div>
            <div v-else>
              <b-button
                style="font-weight: inherit"
                size="sm"
                class="btn-xs"
                :href="toPath(data.item)"
                target="_blank"
                ><b-icon-search></b-icon-search
              ></b-button>
            </div>
          </template>
          <template v-slot:cell(actions)="data">
            <div class="d-flex justify-content-center">
              <b-button
                size="sm"
                class="btn-xs"
                variant="info"
                @click="email_document(data.item)"
                ><b-icon-envelope-fill></b-icon-envelope-fill
              ></b-button>
              <b-button
                v-if="$store.getters.isAdmin"
                class="ml-3 btn-xs"
                size="sm"
                variant="success"
                @click="edit_note(data.item)"
                ><b-icon-pencil-fill></b-icon-pencil-fill
              ></b-button>
              <b-button
                v-if="$store.getters.isSuperAdmin"
                class="ml-3 btn-xs"
                size="sm"
                variant="danger"
                @click="delete_document(data.item.ID)"
                ><b-icon-x-circle></b-icon-x-circle
              ></b-button>
            </div>
          </template>
        </b-table>
        <b-card-body v-else>
          <b-alert show>Pas de documents</b-alert>
        </b-card-body>
        <b-modal
          size="xl"
          :title="imgFullScreenName"
          id="img-full-screen"
          ok-only
          title-class="text-center"
        >
          <img style="width: 100%" :src="imgFullScreenPath" />
        </b-modal>
        <b-modal
          size="xl"
          :title="objectFullScreenName"
          id="object-full-screen"
          ok-only
          title-class="text-center"
        >
          <object
            style="width: 100%; height: 1000px"
            :data="objectFullScreenPath"
            :type="objectFullScreenMtype"
          >
            <embed :src="objectFullScreenPath" :type="objectFullScreenMtype" />
          </object>
        </b-modal>
        <b-modal
          title="Éditer la note"
          id="edit-note"
          size="lg"
          title-class="text-center"
          hide-footer
        >
          <DocumentNote
            v-if="currentItem !== null"
            @change="load()"
            @close="$bvModal.hide('edit-note')"
            :object="object"
            :document_id="currentItem.ID"
          ></DocumentNote>
        </b-modal>
        <b-modal
          title="Envoyer le document par mail"
          id="email-document"
          size="lg"
          title-class="text-center"
          hide-footer
        >
          <DocumentMail
            v-if="currentItem !== null"
            @close="$bvModal.hide('email-document')"
            :object="object"
            :document_id="currentItem.ID"
          ></DocumentMail>
        </b-modal>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import documents from "@/services/documents.js";
import { Upload } from "element-ui";
import DocumentNote from "@/components/DocumentNote";
import DocumentMail from "@/components/DocumentMail";
import "element-ui/lib/theme-chalk/index.css";
export default {
  name: "Documents",
  props: {
    id: [Number, String],
    api: String,
    object: String,
  },
  components: {
    [Upload.name]: Upload,
    DocumentNote,
    DocumentMail,
  },
  data() {
    return {
      documents: [],
      currentItem: null,
      busy: false,
      loaded: false,
      imgFullScreenName: null,
      imgFullScreenPath: null,
      objectFullScreenName: null,
      objectFullScreenPath: null,
      objectFullScreenMtype: null,
      documentType: null,
      fields: [
        {
          key: "emittedBy",
          label: "Source",
          sortable: false,
        },
        {
          key: "date_document",
          label: "Date",
          sortable: true,
        },
        {
          key: "isPrivate",
          label: "Type",
          sortable: false,
          class: "text-center",
        },
        {
          key: "intitule",
          label: "Nom",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "document",
          label: "Document",
          sortable: false,
          class: "text-center",
        },
        {
          key: "actions",
          label: "",
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    handleChange(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$bvToast.toast(
          "Fichier trop lourd! Veillez à ne pas dépasser 100M",
          {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 5000,
            solid: false,
          }
        );
        return false;
      }
    },
    uploadFiles(res) {
      const formData = new FormData();
      formData.append("file", res.file);
      formData.append("type", this.documentType);
      this.busy = true;
      documents.add(this.$props.object, this.$props.id, formData).then(() => {
        this.busy = false;
        this.load();
      });
    },
    load() {
      documents.get(this.$props.object, this.$props.id).then((response) => {
        this.documents = response.data;
        this.loaded = true;
      });
    },
    delete_document(document_id) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer ce document", {
          cancelTitle: "Annuler",
          okTitle: "Supprimer",
        })
        .then((value) => {
          if (value) {
            this.busy = true;
            documents.suppress(this.$props.object, document_id).then(() => {
              this.busy = false;
              this.load();
            });
          }
        });
    },
    edit_note(item) {
      this.currentItem = item;
      this.$bvModal.show("edit-note");
    },
    email_document(item) {
      this.currentItem = item;
      this.$bvModal.show("email-document");
    },
    imgClick(item) {
      this.imgFullScreenName = item.intitule;
      this.imgFullScreenPath = this.toPath(item);

      this.$bvModal.show("img-full-screen");
    },
    toPath(item) {
      if (item.path.indexOf("/upload") == 0) {
        return this.$store.getters.url + item.path;
      }
      return this.$store.getters.url + "/uploadv2" + item.path;
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    printImage(item) {
      let divContents = '<img src="' + this.toPath(item) + '">';
      var a = window.open("", "", "");
      a.document.write("<html>");
      a.document.write("<body > <h1>" + item.intitule + "</h1><br>");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
      a.print();
    },
    fullScreen(item) {
      this.objectFullScreenName = item.intitule;
      this.objectFullScreenPath = this.toPath(item);
      this.objectFullScreenMtype = item.mimeType;
      this.$bvModal.show("object-full-screen");
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail-img {
  img {
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>